export default __webpack_public_path__ + "static/HelveticaMonospacedPro-Rg-1da946e875d8940798b1126ac7f9c3e3.eot";